import { render } from "./unread-indicator.vue?vue&type=template&id=9d82f77f"
const script = {  }

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__